module.exports = __webpack_public_path__ + "img/ao.f2d09c05.svg";